<div class="container-fluid" id="body">
    <div class="row">
        <div class="col-12" *ngIf="isLoading">
            <app-busy [message]="message"></app-busy>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-9">

                </div>
                <div class="col-3 text-right">
                    <strong class="text-right" style="color:rgb(253, 207,76 );">{{user?.UserName}}</strong>
                </div>
            </div>
            <hr>

            <h4 style="margin-bottom:0px;">
                <span style="padding-right:5px"></span> ACCOUNT STATEMENT
            </h4>

            <!-- Carrier Account Details -->
            <div class="col-md-12 p-0 " style="width: 60%; float: left; margin-right: 1%;">
                <div class="card border-light shadow-sm">
                    <div class="row mb-0">
                        <div style="margin-bottom:0px!important;width: 100%!important;" class="col-sm-15 p-0">
                            <div class="col-md-7">
                                <h6 style="margin-bottom:5px;">
                                    <!-- <span style="padding-right:5px"></span> -->
                                    <b>Account Details</b>
                                </h6>
                                <table id="accountdetails-1" style="width: 100%!important; padding-left:25px">
                                    <tbody style="margin:0%!important">
                                        <tr>
                                            <td><span style="color:red" class="head-text"><b>Account ID:</b></span></td>
                                            <td><span style="color:red">{{debtoraccount.customer_code}}</span></td>
                                        </tr>
                                        <tr>
                                            <td><span class="head-text"><b>Account Name:</b></span></td>
                                            <td><span>{{debtoraccount.customer_name}}</span></td>
                                        </tr>
                                        <!-- <tr>
                  <td><span class = "head-text">My Reference:</span></td>
                  <td><span >{{dataCntrl['application'].reference_num}}</span></td>
                </tr> -->
                                        <tr>
                                            <td><span class="head-text"><b>Contact Person:</b></span></td>
                                            <td><span>{{debtoraccount.contact_person}}</span></td>
                                        </tr>
                                        <tr>
                                            <td><span class="head-text"><b>Email Address:</b></span></td>
                                            <td><span>{{debtoraccount.email}}</span></td>
                                        </tr>
                                        <br/>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- End of the Carrier Details -->

            <fieldset class="card border-light shadow-sm" style="width:39%; float: left;">
                <h6 style="margin-bottom:20px;">
                    <span style="padding-right:5px"></span>
                    <b>Filters </b>
                </h6>
                <div class="row" style="margin:4px auto!important;padding:0px;font-size:11px!important; width:100%;">
                    <div class=" col-12 table-responsive-sm" style="width:100%!important;margin:0px;padding:0px;">
                        <table style="padding-left:50px; width:100%!important;margin:0px;" border="0">
                            <style>
                                table {
                                    border-collapse: separate;
                                    border-spacing: 0 3px;
                                }
                                
                                th {
                                    background-color: white;
                                    color: black;
                                }
                                
                                th,
                                td {
                                    width: 500px;
                                    border: 6px auto;
                                    padding: 1px;
                                }
                            </style>

                            <tr>
                                <td>
                                    <h6>Date From : </h6>
                                </td>
                                <td>
                                    <input type="date" style="width:70%;" [ngModel]="dateFrom" (ngModelChange)="dateFrom = $event" name="dateFrom" class="form-control form-control-sm" />
                                </td>
                                <td>
                                    <!--Button with tooltip and no label -->
                                    <div class="main-btn rounded-circle rmp-all" (click)="onSearch()" title="Apply filters..." style="margin-left: 20px!important;" rel="tooltip" data-placement="top">
                                        <span class="fa fa-search fa-2x" style="margin:5.5px auto;color:white!important;" aria-hidden="true"></span>
                                    </div>
                                </td>
                            </tr>
                            <span style="padding: 0px"></span>
                            <tr>
                                <td>
                                    <h6>Date To : </h6>
                                </td>
                                <td>
                                    <input type="date" style="width:70%;" [ngModel]="dateTo" (ngModelChange)="dateTo = $event" name="dateTo" class="form-control form-control-sm" />
                                </td>
                                <td>
                                    <!--Button with tooltip and no label -->
                                    <div class="main-btn rounded-circle rmp-all" (click)="onReset()" title="Reset filters..." style="margin-left: 20px!important;" rel="tooltip" data-placement="top">
                                        <span class="fa fa-undo fa-2x" style="margin:5.5px auto;color:white!important;" aria-hidden="true"></span>
                                    </div>
                                </td>
                            </tr>
                            <span style="padding: 0px"></span>
                        </table>
                    </div>
                </div>

            </fieldset>
            <!-- class="text-right" -->
            <div style="margin-bottom: 5px; text-align: right;">
                <h6>
                    <b>Account Balance: </b>
                    <span style="font-weight: 400;">{{debtoraccount.AccountBalance * -1 ? (debtoraccount.AccountBalance * -1 | currencyFormat) : 'R 0.00' }}</span>
                </h6>
            </div>

            <table class="table table-sm table-striped" style="border-top:none;" id="transactions">
                <thead class="" style="background:white!important;border-top:none;">
                    <tr style="vertical-align:middle;">

                        <th scope="col">Date</th>
                        <th scope="col">Reference Number</th>
                        <th scope="col">Description</th>
                        <th scope="col">Transcation Type</th>
                        <th scope="col" style="text-align: right;">Transcation Total</th>

                    </tr>
                </thead>
                <tr *ngFor="let transc of listTransactions | paginate: { itemsPerPage: 10, currentPage: page }">
                    <td>{{transc.transaction_date | date:'dd/MM/yyyy'}}</td>
                    <td *ngIf="transc.transaction_type == 'INV'"><a href="javascript:void(0);" (click)="(GetInvoice(transc.reference_number))">{{transc.reference_number}}</a></td>
                    <td *ngIf="transc.transaction_type != 'INV'">{{transc.reference_number}}</td>
                    <td>{{transc.transaction_description}}</td>
                    <td>{{transc.transaction_type}}</td>
                    <td class="text-right">{{transc.transaction_total * -1 ? (transc.transaction_total *-1 | currencyFormat) : 'R 0.00' }}</td>
                </tr>
                <tfoot>
                    <tr *ngIf="listTransactions.length > 0">
                        <td colspan="9" class="rm-brd">
                            <pagination-controls (pageChange)="page = $event" style="margin:0px;padding:0px;"></pagination-controls>
                        </td>
                    </tr>
                    <tr *ngIf="count===0">
                        <td colspan="9" class="rm-brd">
                            <span class="text-info text-small">No Transactions Available for this account.</span>
                        </td>
                    </tr>
                </tfoot>
                <!-- <tfoot style="padding:0px;margin:0px;">
          <tr *ngIf="count > 10" style="padding-left:0px;margin-left:0px;">
            <td colspan="8" class="rm-brd" style="padding-left:0px;margin-left:0px;">
              <div class="row">

                <div class="col-2">
                  <div class="input-group mb-3 rm-brd" style="width:125px!important;height:30px!important;">
                    <div class="input-group-prepend">
                      <label class="input-group-text form-control-sm show-h" for="show-id" style="">Show:</label>
                    </div>
                    <select class="form-control form-control-sm show-h" id="show-id" [(ngModel)]="pageSize" (change)="onChange()">
                      <option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-8 text-center">
                  <pagination-controls (pageChange)="page = $event" style="margin:0px;padding:0px;"></pagination-controls>
                </div>
              </div>
            </td>
          </tr>
          <tr *ngIf="isEmpty">
            <td colspan="4" class="rm-brd">
              <span class="text-info text-small">No Transactions Available for this account.</span>
            </td>
          </tr>
        </tfoot> -->
            </table>
        </div>
    </div>

    <!-- <footer style="margin:0px;padding:0px;">
  <div class="row" style="margin:0px;padding:0px;">
    
    <div class="col-12" style="margin:0px;padding:0px;"> -->
    <!--<footer class="footer">-->
    <!-- <div class="container-fluid" style="background-color:rgb(242,242,242) !important;height:75px!important;margin-bottom:1px!important;">
    <div class="row">
      <div class="col-md-12" *ngIf="isLoading">
        <app-busy [message]="message"></app-busy>
      </div>
      <div class="col-6"></div>
      <div class="col-6">
        <div class="row">
          <div style="width: 70px;height: 70px;" class="col-2">
            <div class="" title="Cancel" style="margin: 0px auto;" rel="tooltip" data-placement="top">
              <div class="app-cancel" (click)="cancel()"></div>
            </div> -->
    <!-- <div class="lbl-app" style="margin: 1px auto;">
              <span>Cancel</span>
            </div> -->
    <!-- </div>
          <div style="width: 70px;height: 70px;" class="col-2">
            <div class="" title="Download Statement" style="margin: 0px auto;" rel="tooltip" data-placement="top">
                  <div id="download-statement"  (click)="download()"></div>
            </div>
          </div>
          <div style="width: 70px;height: 70px;" class="col-2">
            <div class="" title="Email Statement" style="margin: 0px auto;" rel="tooltip" data-placement="top">
             <div id="email-statement"  (click)="emailStatement()"></div>
           </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
    <!--</footer>-->
    <!-- </div>
   
    </div>
</footer> -->
